import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import moment from "moment";
import excelJs from "exceljs";
import UserListToolbar from "./UserListToolbar";
import UserListHead from "./UserListHead";
import SearchNotFound from "../../../SearchNotFound";
import { getProfile } from "../../../../core/service/users.service";
import { setUserProfile } from "../../../../core/redux/action/userProfile";
import Page from "../../../Page";

// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import DownloadIcon from "@mui/icons-material/Download";
// import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
// import { Icon } from "@iconify/react";
import {
  Card,
  Container,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Link,
  TableHead,
  Collapse,
  Box,
} from "@mui/material";
import { config } from "../../../../core/service/config.service";

const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD3Y = "phd_3y";
const ROLE_PHD5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const applySortFilter = (array, comparator, query) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    // const searchMentor =
    return array.filter((e) => {
      const nameMentor = `${e.title_name_en} ${e.name_en} ${
        e.middle_en || ""
      } ${e.surname_en}`;
      return nameMentor.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });

    // const searchSTD = array.filter((_user) => {
    //   const stdSearch = _user.std.filter((e) => e.name_en.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    //   if (stdSearch.length !== 0) return stdSearch;
    // });

    // switch (true) {
    //   case searchMentor.length !== 0 && searchSTD.length !== 0:
    //     let newSearch = searchMentor.concat(searchSTD);
    //     newSearch = [...new Set([...searchMentor, ...searchSTD])];
    //     return newSearch;
    //   case searchMentor.length !== 0:
    //     return searchMentor;
    //   case searchSTD.length !== 0:
    //     return searchSTD;
    //   default:
    //     return [];
    // }
  }
  return stabilizedThis.map((el) => el[0]);
};

const CollapsibleTable = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { row } = props;

  const rowPostDoc = row.std.filter((e) => e.role === "post_doc");
  const rowPhD = row.std.filter((e) => e.role !== "post_doc");

  return (
    <>
      {/* PostDoc */}
      <Collapse in={true} timeout="auto" unmountOnExit>
        <Box sx={{ margin: 1 }}>
          <Typography variant="h6" gutterBottom component="div">
            PostDoc
          </Typography>
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>PostDoc ID</TableCell>
                <TableCell>Faculty</TableCell>
                <TableCell>Email</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowPostDoc.map((stdRow) => (
                <TableRow key={stdRow.id}>
                  <TableCell component="th" scope="row">
                    <Link
                      underline="hover"
                      color="inherit"
                      component="button"
                      onClick={async () => {
                        await dispatch(setUserProfile(stdRow));
                        navigate(
                          `/anotherProfile/${stdRow.role}/${stdRow.id}`,
                          {
                            replace: true,
                          }
                        );
                      }}
                    >
                      {stdRow.name}
                    </Link>
                  </TableCell>
                  <TableCell>{stdRow.id}</TableCell>
                  <TableCell>{row.company}</TableCell>
                  <TableCell>{stdRow.email}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Collapse>

      {/* PhD */}
      <Collapse in={true} timeout="auto" unmountOnExit>
        <Box sx={{ margin: 1 }}>
          <Typography variant="h6" gutterBottom component="div">
            PhD
          </Typography>
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>PhD ID</TableCell>
                <TableCell>Faculty</TableCell>
                <TableCell>Email</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowPhD.map((stdRow) => (
                <TableRow key={stdRow.id}>
                  <TableCell component="th" scope="row">
                    <Link
                      underline="hover"
                      color="inherit"
                      component="button"
                      onClick={async () => {
                        await dispatch(setUserProfile(stdRow));
                        navigate(`/anotherProfile/${stdRow.id}`, {
                          replace: true,
                        });
                      }}
                    >
                      {stdRow.name}
                    </Link>
                  </TableCell>
                  <TableCell>{stdRow.id}</TableCell>
                  <TableCell>{row.company}</TableCell>
                  <TableCell>{stdRow.email}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Collapse>
    </>
  );
};

const ExpandableTableRow = ({
  role,
  children,
  expandComponent,
  checkPageForArrowDownIcon,
  ...otherProps
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <TableRow {...otherProps}>
        <TableCell padding="checkbox"></TableCell>
        {children}
      </TableRow>
      {isExpanded && (
        <TableRow hover>
          <TableCell padding="checkbox" />
          {expandComponent}
        </TableRow>
      )}
    </>
  );
};

UserTable.propTypes = {
  ListUsers: PropTypes.array,
  currentUserRole: PropTypes.string,
  checkPage: PropTypes.string,
};

export default function UserTable({ ListUsers, currentUserRole, checkPage }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const TABLE_HEAD_MENTOR = [
    { id: "student_id", label: "ID", alignRight: false },
    { id: "name_en", label: "Name", alignRight: false },
    { id: "email", label: "Email", alignRight: false },
    { id: "faculty", label: "Faculty", alignRight: false },
    { id: "role_nm", label: "Program", alignRight: false },
    { id: "start_reciving", label: "Start Month", alignRight: false },
  ];

  const TABLE_HEAD_ADMIN = [
    { id: "name_en", label: "Name", alignRight: false },
    { id: "email", label: "Email", alignCenter: true },
    { id: "faculty", label: "Faculty", alignCenter: true },
    { id: "nember_std", label: "Number of Grantee", alignCenter: true },
  ];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ListUsers.length) : 0;

  const filteredUsers = applySortFilter(
    ListUsers,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;

  const exportExcel = async () => {
    const workbook = new excelJs.Workbook();
    const ws = workbook.addWorksheet(`Report`);
    if (currentUserRole === ROLE_ADMIN) {
      ws.columns = [
        {
          header: "Name",
          key: "name",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Email",
          key: "email",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Faculty",
          key: "faculty",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Number of Grantee",
          key: "nember_std",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
      ];
    } else {
      ws.columns = [
        {
          header: "ID",
          key: "student_id",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Name",
          key: "name_en",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Email",
          key: "email",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Faculty",
          key: "faculty",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Program",
          key: "role_nm",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
        {
          header: "Start Month",
          key: "start_reciving",
          width: 10,
          style: {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
          },
        },
      ];
    }

    ws.getRow(1).height = 30;

    await Promise.all(
      filteredUsers.map(async (val, index) => {
        if (currentUserRole === ROLE_ADMIN) {
          ws.addRow([
            `${val.name_en} ${val.middle_en || ""} ${val.surname_en}`,
            val.email,
            val.faculty,
            val.nember_std,
          ]);
        } else {
          ws.addRow([
            val.student_id,
            `${val.name_en} ${val.middle_en || ""} ${val.surname_en}`,
            val.email,
            val.faculty,
            val.role_nm === ROLE_POSTDOC
              ? "Post Doc"
              : val.role_nm === ROLE_PHD3Y
              ? "PhD 3 year"
              : "PhD 5 year",
            moment(val.start_reciving).format("DD/MM/YYYY") === "Invalid date"
              ? "-"
              : moment(val.start_reciving).format("DD/MM/YYYY"),
          ]);
        }
        ws.getRow(index + 2).font = {
          ...ws.getRow(index + 2).font,
          bold: false,
        };
      })
    );

    workbook.xlsx
      .writeBuffer({
        base64: true,
      })
      .then((xls64) => {
        // build anchor tag and attach file (works in chrome)
        var a = document.createElement("a");
        var data = new Blob([xls64], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        var url = URL.createObjectURL(data);
        a.href = url;
        if (currentUserRole === ROLE_ADMIN) {
          a.download = `MEMBER_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
        } else {
          a.download = `GRANTEE_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
        }
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      })
      .catch(function (error) {
        console.log(error.message);
      });
  };

  return (
    <Page title="Member">
      <Container>
        {currentUserRole === ROLE_ADMIN && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Mentor
            </Typography>
            <Link href={`${config.host_api}export/mentor`}>
              <Button variant="contained" >
                Export excel
              </Button>
            </Link>
          </Stack>
        )}

        <Card>
          <UserListToolbar
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={
                  currentUserRole === ROLE_ADMIN
                    ? TABLE_HEAD_ADMIN
                    : TABLE_HEAD_MENTOR
                }
                rowCount={ListUsers.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, i) => {
                    const {
                      email,
                      faculty,
                      middle_en,
                      name_en,
                      role_nm,
                      start_reciving,
                      student_id,
                      surname_en,
                      nember_std,
                      users_id,
                    } = row;

                    const name = `${name_en} ${middle_en || ""} ${surname_en}`;
                    const nameMentor = `${name_en} ${
                      middle_en || ""
                    } ${surname_en}`;
                    const start_reciving_date =
                      moment(start_reciving).format("DD/MM/YYYY");

                    return (
                      <ExpandableTableRow
                        tabIndex={-1}
                        hover
                        key={i}
                        checkPageForArrowDownIcon={checkPage}
                        role={currentUserRole}
                        expandComponent={
                          <TableCell colSpan="5">
                            <CollapsibleTable row={row} />
                          </TableCell>
                        }
                      >
                        {currentUserRole === ROLE_MENTOR && (
                          <>
                            <TableCell align="left">
                              {student_id || "-"}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                              >
                                <Link
                                  underline="hover"
                                  color="inherit"
                                  variant="subtitle2"
                                  component="button"
                                  onClick={async () => {
                                    const data = await getProfile(users_id);
                                    await dispatch(setUserProfile(data));
                                    const { role, personal_infomation } = data;
                                    navigate(
                                      `/anotherProfile/${role.role}/${personal_infomation.student_id}`,
                                      {
                                        replace: true,
                                      }
                                    );
                                  }}
                                >
                                  {name}
                                </Link>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">{faculty}</TableCell>
                            <TableCell align="left">
                              {role_nm === ROLE_POSTDOC
                                ? "Post Doc"
                                : role_nm === ROLE_PHD3Y
                                ? "PhD 3 year"
                                : "PhD 5 year"}
                            </TableCell>
                            <TableCell align="left">
                              {start_reciving_date === "Invalid date"
                                ? "-"
                                : start_reciving_date}
                            </TableCell>
                          </>
                        )}

                        {currentUserRole === ROLE_ADMIN && (
                          <>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                              >
                                <Link
                                  underline="hover"
                                  color="inherit"
                                  variant="subtitle2"
                                  component="button"
                                  onClick={async () => {
                                    const data = await getProfile(users_id);
                                    await dispatch(setUserProfile(data));
                                    const { role, personal_infomation } = data;
                                    const nameMentor = `${
                                      personal_infomation.title_name_en
                                    }${personal_infomation.name_en}${
                                      personal_infomation.middle_en || ""
                                    }${personal_infomation.surname_en}`;
                                    navigate(
                                      `/anotherProfile/${role.role}/${nameMentor}`,
                                      {
                                        replace: true,
                                      }
                                    );
                                  }}
                                >
                                  {nameMentor}
                                </Link>
                              </Stack>
                            </TableCell>
                            <TableCell align="center">{email}</TableCell>
                            <TableCell align="center">{faculty}</TableCell>
                            <TableCell align="center">{nember_std}</TableCell>
                          </>
                        )}
                      </ExpandableTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={ListUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {currentUserRole === ROLE_MENTOR && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
            sx={{ marginTop: 5 }}
          >
            <Typography variant="h4" gutterBottom></Typography>
            <Button variant="contained" onClick={exportExcel}>
              Export excel
            </Button>
          </Stack>
        )}
      </Container>
    </Page>
  );
}
